/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UssdSimulatorImport } from './routes/ussd-simulator'
import { Route as TermsImport } from './routes/terms'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as LayoutForbiddenImport } from './routes/_layout/forbidden'
import { Route as authResetPasswordImport } from './routes/(auth)/reset-password'
import { Route as authLoginImport } from './routes/(auth)/login'
import { Route as authForgotPasswordImport } from './routes/(auth)/forgot-password'
import { Route as LayoutUsersIndexImport } from './routes/_layout/users/index'
import { Route as LayoutSupportIndexImport } from './routes/_layout/support/index'
import { Route as LayoutSettingsIndexImport } from './routes/_layout/settings/index'
import { Route as LayoutRolesIndexImport } from './routes/_layout/roles/index'
import { Route as LayoutPortfolioIndexImport } from './routes/_layout/portfolio/index'
import { Route as LayoutPaymentsIndexImport } from './routes/_layout/payments/index'
import { Route as LayoutNotificationsIndexImport } from './routes/_layout/notifications/index'
import { Route as LayoutMerchantsIndexImport } from './routes/_layout/merchants/index'
import { Route as LayoutLockEngineIndexImport } from './routes/_layout/lock-engine/index'
import { Route as LayoutInventoryIndexImport } from './routes/_layout/inventory/index'
import { Route as LayoutFinancingPlansIndexImport } from './routes/_layout/financing-plans/index'
import { Route as LayoutFeedbackIndexImport } from './routes/_layout/feedback/index'
import { Route as LayoutDeviceModelsIndexImport } from './routes/_layout/device-models/index'
import { Route as LayoutCustomersIndexImport } from './routes/_layout/customers/index'
import { Route as LayoutContractsIndexImport } from './routes/_layout/contracts/index'
import { Route as LayoutCollectionsIndexImport } from './routes/_layout/collections/index'
import { Route as LayoutAuditLogsIndexImport } from './routes/_layout/audit-logs/index'
import { Route as LayoutApplicationsIndexImport } from './routes/_layout/applications/index'
import { Route as LayoutUsersNewImport } from './routes/_layout/users/new'
import { Route as LayoutUsersUserIdImport } from './routes/_layout/users/$userId'
import { Route as LayoutSupportTicketIdImport } from './routes/_layout/support/$ticketId'
import { Route as LayoutSettingsTenantImport } from './routes/_layout/settings/tenant'
import { Route as LayoutSettingsPoliciesImport } from './routes/_layout/settings/policies'
import { Route as LayoutSettingsOperationsImport } from './routes/_layout/settings/operations'
import { Route as LayoutSettingsInstallmentImport } from './routes/_layout/settings/installment'
import { Route as LayoutSettingsBranchesImport } from './routes/_layout/settings/branches'
import { Route as LayoutSettingsActionControlsImport } from './routes/_layout/settings/action-controls'
import { Route as LayoutRolesNewImport } from './routes/_layout/roles/new'
import { Route as LayoutRolesRoleIdImport } from './routes/_layout/roles/$roleId'
import { Route as LayoutPaymentsRecordImport } from './routes/_layout/payments/record'
import { Route as LayoutMerchantsNewImport } from './routes/_layout/merchants/new'
import { Route as LayoutMerchantsMerchantIdImport } from './routes/_layout/merchants/$merchantId'
import { Route as LayoutLockEnginePoliciesImport } from './routes/_layout/lock-engine/policies'
import { Route as LayoutLockEngineAutomationImport } from './routes/_layout/lock-engine/automation'
import { Route as LayoutFinancingPlansNewImport } from './routes/_layout/financing-plans/new'
import { Route as LayoutDeviceModelsNewImport } from './routes/_layout/device-models/new'
import { Route as LayoutDeviceModelsModelIdImport } from './routes/_layout/device-models/$modelId'
import { Route as LayoutCustomersNewImport } from './routes/_layout/customers/new'
import { Route as LayoutCustomersCustomerIdImport } from './routes/_layout/customers/$customerId'
import { Route as LayoutContractsContractIdImport } from './routes/_layout/contracts/$contractId'
import { Route as LayoutApplicationsNewImport } from './routes/_layout/applications/new'
import { Route as LayoutApplicationsApplicationIdImport } from './routes/_layout/applications/$applicationId'
import { Route as LayoutSettingsOdooIndexImport } from './routes/_layout/settings/odoo/index'
import { Route as LayoutInventoryUnitsIndexImport } from './routes/_layout/inventory/units/index'
import { Route as LayoutInventoryTransfersIndexImport } from './routes/_layout/inventory/transfers/index'
import { Route as LayoutSettingsPlatformProductsImport } from './routes/_layout/settings/platform/products'
import { Route as LayoutSettingsOdooSyncImport } from './routes/_layout/settings/odoo/sync'
import { Route as LayoutSettingsOdooReconciliationImport } from './routes/_layout/settings/odoo/reconciliation'
import { Route as LayoutSettingsOdooOpeningBalancesImport } from './routes/_layout/settings/odoo/opening-balances'
import { Route as LayoutInventoryUnitsEnrollImport } from './routes/_layout/inventory/units/enroll'
import { Route as LayoutInventoryUnitsUnitIdImport } from './routes/_layout/inventory/units/$unitId'
import { Route as LayoutFinancingPlansPlanIdEditImport } from './routes/_layout/financing-plans/$planId.edit'
import { Route as LayoutSettingsPlatformTenantsIndexImport } from './routes/_layout/settings/platform/tenants/index'
import { Route as LayoutSettingsPlatformTenantsTenantIdImport } from './routes/_layout/settings/platform/tenants/$tenantId'

// Create/Update Routes

const UssdSimulatorRoute = UssdSimulatorImport.update({
  id: '/ussd-simulator',
  path: '/ussd-simulator',
  getParentRoute: () => rootRoute,
} as any)

const TermsRoute = TermsImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutForbiddenRoute = LayoutForbiddenImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => LayoutRoute,
} as any)

const authResetPasswordRoute = authResetPasswordImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const authLoginRoute = authLoginImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const authForgotPasswordRoute = authForgotPasswordImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const LayoutUsersIndexRoute = LayoutUsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSupportIndexRoute = LayoutSupportIndexImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsIndexRoute = LayoutSettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutRolesIndexRoute = LayoutRolesIndexImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPortfolioIndexRoute = LayoutPortfolioIndexImport.update({
  id: '/portfolio/',
  path: '/portfolio/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPaymentsIndexRoute = LayoutPaymentsIndexImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutNotificationsIndexRoute = LayoutNotificationsIndexImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMerchantsIndexRoute = LayoutMerchantsIndexImport.update({
  id: '/merchants/',
  path: '/merchants/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLockEngineIndexRoute = LayoutLockEngineIndexImport.update({
  id: '/lock-engine/',
  path: '/lock-engine/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutInventoryIndexRoute = LayoutInventoryIndexImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutFinancingPlansIndexRoute = LayoutFinancingPlansIndexImport.update({
  id: '/financing-plans/',
  path: '/financing-plans/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutFeedbackIndexRoute = LayoutFeedbackIndexImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDeviceModelsIndexRoute = LayoutDeviceModelsIndexImport.update({
  id: '/device-models/',
  path: '/device-models/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutCustomersIndexRoute = LayoutCustomersIndexImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutContractsIndexRoute = LayoutContractsIndexImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutCollectionsIndexRoute = LayoutCollectionsIndexImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAuditLogsIndexRoute = LayoutAuditLogsIndexImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutApplicationsIndexRoute = LayoutApplicationsIndexImport.update({
  id: '/applications/',
  path: '/applications/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUsersNewRoute = LayoutUsersNewImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUsersUserIdRoute = LayoutUsersUserIdImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSupportTicketIdRoute = LayoutSupportTicketIdImport.update({
  id: '/support/$ticketId',
  path: '/support/$ticketId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsTenantRoute = LayoutSettingsTenantImport.update({
  id: '/settings/tenant',
  path: '/settings/tenant',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsPoliciesRoute = LayoutSettingsPoliciesImport.update({
  id: '/settings/policies',
  path: '/settings/policies',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsOperationsRoute = LayoutSettingsOperationsImport.update({
  id: '/settings/operations',
  path: '/settings/operations',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsInstallmentRoute = LayoutSettingsInstallmentImport.update({
  id: '/settings/installment',
  path: '/settings/installment',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsBranchesRoute = LayoutSettingsBranchesImport.update({
  id: '/settings/branches',
  path: '/settings/branches',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsActionControlsRoute =
  LayoutSettingsActionControlsImport.update({
    id: '/settings/action-controls',
    path: '/settings/action-controls',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutRolesNewRoute = LayoutRolesNewImport.update({
  id: '/roles/new',
  path: '/roles/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutRolesRoleIdRoute = LayoutRolesRoleIdImport.update({
  id: '/roles/$roleId',
  path: '/roles/$roleId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutPaymentsRecordRoute = LayoutPaymentsRecordImport.update({
  id: '/payments/record',
  path: '/payments/record',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMerchantsNewRoute = LayoutMerchantsNewImport.update({
  id: '/merchants/new',
  path: '/merchants/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMerchantsMerchantIdRoute = LayoutMerchantsMerchantIdImport.update({
  id: '/merchants/$merchantId',
  path: '/merchants/$merchantId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLockEnginePoliciesRoute = LayoutLockEnginePoliciesImport.update({
  id: '/lock-engine/policies',
  path: '/lock-engine/policies',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLockEngineAutomationRoute = LayoutLockEngineAutomationImport.update(
  {
    id: '/lock-engine/automation',
    path: '/lock-engine/automation',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutFinancingPlansNewRoute = LayoutFinancingPlansNewImport.update({
  id: '/financing-plans/new',
  path: '/financing-plans/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDeviceModelsNewRoute = LayoutDeviceModelsNewImport.update({
  id: '/device-models/new',
  path: '/device-models/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDeviceModelsModelIdRoute = LayoutDeviceModelsModelIdImport.update({
  id: '/device-models/$modelId',
  path: '/device-models/$modelId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutCustomersNewRoute = LayoutCustomersNewImport.update({
  id: '/customers/new',
  path: '/customers/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutCustomersCustomerIdRoute = LayoutCustomersCustomerIdImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutContractsContractIdRoute = LayoutContractsContractIdImport.update({
  id: '/contracts/$contractId',
  path: '/contracts/$contractId',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutApplicationsNewRoute = LayoutApplicationsNewImport.update({
  id: '/applications/new',
  path: '/applications/new',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutApplicationsApplicationIdRoute =
  LayoutApplicationsApplicationIdImport.update({
    id: '/applications/$applicationId',
    path: '/applications/$applicationId',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSettingsOdooIndexRoute = LayoutSettingsOdooIndexImport.update({
  id: '/settings/odoo/',
  path: '/settings/odoo/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutInventoryUnitsIndexRoute = LayoutInventoryUnitsIndexImport.update({
  id: '/inventory/units/',
  path: '/inventory/units/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutInventoryTransfersIndexRoute =
  LayoutInventoryTransfersIndexImport.update({
    id: '/inventory/transfers/',
    path: '/inventory/transfers/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSettingsPlatformProductsRoute =
  LayoutSettingsPlatformProductsImport.update({
    id: '/settings/platform/products',
    path: '/settings/platform/products',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSettingsOdooSyncRoute = LayoutSettingsOdooSyncImport.update({
  id: '/settings/odoo/sync',
  path: '/settings/odoo/sync',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsOdooReconciliationRoute =
  LayoutSettingsOdooReconciliationImport.update({
    id: '/settings/odoo/reconciliation',
    path: '/settings/odoo/reconciliation',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSettingsOdooOpeningBalancesRoute =
  LayoutSettingsOdooOpeningBalancesImport.update({
    id: '/settings/odoo/opening-balances',
    path: '/settings/odoo/opening-balances',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutInventoryUnitsEnrollRoute = LayoutInventoryUnitsEnrollImport.update(
  {
    id: '/inventory/units/enroll',
    path: '/inventory/units/enroll',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutInventoryUnitsUnitIdRoute = LayoutInventoryUnitsUnitIdImport.update(
  {
    id: '/inventory/units/$unitId',
    path: '/inventory/units/$unitId',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutFinancingPlansPlanIdEditRoute =
  LayoutFinancingPlansPlanIdEditImport.update({
    id: '/financing-plans/$planId/edit',
    path: '/financing-plans/$planId/edit',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSettingsPlatformTenantsIndexRoute =
  LayoutSettingsPlatformTenantsIndexImport.update({
    id: '/settings/platform/tenants/',
    path: '/settings/platform/tenants/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutSettingsPlatformTenantsTenantIdRoute =
  LayoutSettingsPlatformTenantsTenantIdImport.update({
    id: '/settings/platform/tenants/$tenantId',
    path: '/settings/platform/tenants/$tenantId',
    getParentRoute: () => LayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsImport
      parentRoute: typeof rootRoute
    }
    '/ussd-simulator': {
      id: '/ussd-simulator'
      path: '/ussd-simulator'
      fullPath: '/ussd-simulator'
      preLoaderRoute: typeof UssdSimulatorImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_layout/forbidden': {
      id: '/_layout/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof LayoutForbiddenImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/applications/$applicationId': {
      id: '/_layout/applications/$applicationId'
      path: '/applications/$applicationId'
      fullPath: '/applications/$applicationId'
      preLoaderRoute: typeof LayoutApplicationsApplicationIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/applications/new': {
      id: '/_layout/applications/new'
      path: '/applications/new'
      fullPath: '/applications/new'
      preLoaderRoute: typeof LayoutApplicationsNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/contracts/$contractId': {
      id: '/_layout/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/contracts/$contractId'
      preLoaderRoute: typeof LayoutContractsContractIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/customers/$customerId': {
      id: '/_layout/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof LayoutCustomersCustomerIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/customers/new': {
      id: '/_layout/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof LayoutCustomersNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/device-models/$modelId': {
      id: '/_layout/device-models/$modelId'
      path: '/device-models/$modelId'
      fullPath: '/device-models/$modelId'
      preLoaderRoute: typeof LayoutDeviceModelsModelIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/device-models/new': {
      id: '/_layout/device-models/new'
      path: '/device-models/new'
      fullPath: '/device-models/new'
      preLoaderRoute: typeof LayoutDeviceModelsNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/financing-plans/new': {
      id: '/_layout/financing-plans/new'
      path: '/financing-plans/new'
      fullPath: '/financing-plans/new'
      preLoaderRoute: typeof LayoutFinancingPlansNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lock-engine/automation': {
      id: '/_layout/lock-engine/automation'
      path: '/lock-engine/automation'
      fullPath: '/lock-engine/automation'
      preLoaderRoute: typeof LayoutLockEngineAutomationImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lock-engine/policies': {
      id: '/_layout/lock-engine/policies'
      path: '/lock-engine/policies'
      fullPath: '/lock-engine/policies'
      preLoaderRoute: typeof LayoutLockEnginePoliciesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/merchants/$merchantId': {
      id: '/_layout/merchants/$merchantId'
      path: '/merchants/$merchantId'
      fullPath: '/merchants/$merchantId'
      preLoaderRoute: typeof LayoutMerchantsMerchantIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/merchants/new': {
      id: '/_layout/merchants/new'
      path: '/merchants/new'
      fullPath: '/merchants/new'
      preLoaderRoute: typeof LayoutMerchantsNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/payments/record': {
      id: '/_layout/payments/record'
      path: '/payments/record'
      fullPath: '/payments/record'
      preLoaderRoute: typeof LayoutPaymentsRecordImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/roles/$roleId': {
      id: '/_layout/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof LayoutRolesRoleIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/roles/new': {
      id: '/_layout/roles/new'
      path: '/roles/new'
      fullPath: '/roles/new'
      preLoaderRoute: typeof LayoutRolesNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/action-controls': {
      id: '/_layout/settings/action-controls'
      path: '/settings/action-controls'
      fullPath: '/settings/action-controls'
      preLoaderRoute: typeof LayoutSettingsActionControlsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/branches': {
      id: '/_layout/settings/branches'
      path: '/settings/branches'
      fullPath: '/settings/branches'
      preLoaderRoute: typeof LayoutSettingsBranchesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/installment': {
      id: '/_layout/settings/installment'
      path: '/settings/installment'
      fullPath: '/settings/installment'
      preLoaderRoute: typeof LayoutSettingsInstallmentImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/operations': {
      id: '/_layout/settings/operations'
      path: '/settings/operations'
      fullPath: '/settings/operations'
      preLoaderRoute: typeof LayoutSettingsOperationsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/policies': {
      id: '/_layout/settings/policies'
      path: '/settings/policies'
      fullPath: '/settings/policies'
      preLoaderRoute: typeof LayoutSettingsPoliciesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/tenant': {
      id: '/_layout/settings/tenant'
      path: '/settings/tenant'
      fullPath: '/settings/tenant'
      preLoaderRoute: typeof LayoutSettingsTenantImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/support/$ticketId': {
      id: '/_layout/support/$ticketId'
      path: '/support/$ticketId'
      fullPath: '/support/$ticketId'
      preLoaderRoute: typeof LayoutSupportTicketIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/users/$userId': {
      id: '/_layout/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof LayoutUsersUserIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/users/new': {
      id: '/_layout/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof LayoutUsersNewImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/applications/': {
      id: '/_layout/applications/'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof LayoutApplicationsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/audit-logs/': {
      id: '/_layout/audit-logs/'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof LayoutAuditLogsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/collections/': {
      id: '/_layout/collections/'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof LayoutCollectionsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/contracts/': {
      id: '/_layout/contracts/'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof LayoutContractsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/customers/': {
      id: '/_layout/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof LayoutCustomersIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/device-models/': {
      id: '/_layout/device-models/'
      path: '/device-models'
      fullPath: '/device-models'
      preLoaderRoute: typeof LayoutDeviceModelsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/feedback/': {
      id: '/_layout/feedback/'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof LayoutFeedbackIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/financing-plans/': {
      id: '/_layout/financing-plans/'
      path: '/financing-plans'
      fullPath: '/financing-plans'
      preLoaderRoute: typeof LayoutFinancingPlansIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/inventory/': {
      id: '/_layout/inventory/'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof LayoutInventoryIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lock-engine/': {
      id: '/_layout/lock-engine/'
      path: '/lock-engine'
      fullPath: '/lock-engine'
      preLoaderRoute: typeof LayoutLockEngineIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/merchants/': {
      id: '/_layout/merchants/'
      path: '/merchants'
      fullPath: '/merchants'
      preLoaderRoute: typeof LayoutMerchantsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/notifications/': {
      id: '/_layout/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof LayoutNotificationsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/payments/': {
      id: '/_layout/payments/'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof LayoutPaymentsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/portfolio/': {
      id: '/_layout/portfolio/'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof LayoutPortfolioIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/roles/': {
      id: '/_layout/roles/'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof LayoutRolesIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/': {
      id: '/_layout/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/support/': {
      id: '/_layout/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof LayoutSupportIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/users/': {
      id: '/_layout/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof LayoutUsersIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/financing-plans/$planId/edit': {
      id: '/_layout/financing-plans/$planId/edit'
      path: '/financing-plans/$planId/edit'
      fullPath: '/financing-plans/$planId/edit'
      preLoaderRoute: typeof LayoutFinancingPlansPlanIdEditImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/inventory/units/$unitId': {
      id: '/_layout/inventory/units/$unitId'
      path: '/inventory/units/$unitId'
      fullPath: '/inventory/units/$unitId'
      preLoaderRoute: typeof LayoutInventoryUnitsUnitIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/inventory/units/enroll': {
      id: '/_layout/inventory/units/enroll'
      path: '/inventory/units/enroll'
      fullPath: '/inventory/units/enroll'
      preLoaderRoute: typeof LayoutInventoryUnitsEnrollImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/odoo/opening-balances': {
      id: '/_layout/settings/odoo/opening-balances'
      path: '/settings/odoo/opening-balances'
      fullPath: '/settings/odoo/opening-balances'
      preLoaderRoute: typeof LayoutSettingsOdooOpeningBalancesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/odoo/reconciliation': {
      id: '/_layout/settings/odoo/reconciliation'
      path: '/settings/odoo/reconciliation'
      fullPath: '/settings/odoo/reconciliation'
      preLoaderRoute: typeof LayoutSettingsOdooReconciliationImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/odoo/sync': {
      id: '/_layout/settings/odoo/sync'
      path: '/settings/odoo/sync'
      fullPath: '/settings/odoo/sync'
      preLoaderRoute: typeof LayoutSettingsOdooSyncImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/platform/products': {
      id: '/_layout/settings/platform/products'
      path: '/settings/platform/products'
      fullPath: '/settings/platform/products'
      preLoaderRoute: typeof LayoutSettingsPlatformProductsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/inventory/transfers/': {
      id: '/_layout/inventory/transfers/'
      path: '/inventory/transfers'
      fullPath: '/inventory/transfers'
      preLoaderRoute: typeof LayoutInventoryTransfersIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/inventory/units/': {
      id: '/_layout/inventory/units/'
      path: '/inventory/units'
      fullPath: '/inventory/units'
      preLoaderRoute: typeof LayoutInventoryUnitsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/odoo/': {
      id: '/_layout/settings/odoo/'
      path: '/settings/odoo'
      fullPath: '/settings/odoo'
      preLoaderRoute: typeof LayoutSettingsOdooIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/platform/tenants/$tenantId': {
      id: '/_layout/settings/platform/tenants/$tenantId'
      path: '/settings/platform/tenants/$tenantId'
      fullPath: '/settings/platform/tenants/$tenantId'
      preLoaderRoute: typeof LayoutSettingsPlatformTenantsTenantIdImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings/platform/tenants/': {
      id: '/_layout/settings/platform/tenants/'
      path: '/settings/platform/tenants'
      fullPath: '/settings/platform/tenants'
      preLoaderRoute: typeof LayoutSettingsPlatformTenantsIndexImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

interface LayoutRouteChildren {
  LayoutForbiddenRoute: typeof LayoutForbiddenRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutApplicationsApplicationIdRoute: typeof LayoutApplicationsApplicationIdRoute
  LayoutApplicationsNewRoute: typeof LayoutApplicationsNewRoute
  LayoutContractsContractIdRoute: typeof LayoutContractsContractIdRoute
  LayoutCustomersCustomerIdRoute: typeof LayoutCustomersCustomerIdRoute
  LayoutCustomersNewRoute: typeof LayoutCustomersNewRoute
  LayoutDeviceModelsModelIdRoute: typeof LayoutDeviceModelsModelIdRoute
  LayoutDeviceModelsNewRoute: typeof LayoutDeviceModelsNewRoute
  LayoutFinancingPlansNewRoute: typeof LayoutFinancingPlansNewRoute
  LayoutLockEngineAutomationRoute: typeof LayoutLockEngineAutomationRoute
  LayoutLockEnginePoliciesRoute: typeof LayoutLockEnginePoliciesRoute
  LayoutMerchantsMerchantIdRoute: typeof LayoutMerchantsMerchantIdRoute
  LayoutMerchantsNewRoute: typeof LayoutMerchantsNewRoute
  LayoutPaymentsRecordRoute: typeof LayoutPaymentsRecordRoute
  LayoutRolesRoleIdRoute: typeof LayoutRolesRoleIdRoute
  LayoutRolesNewRoute: typeof LayoutRolesNewRoute
  LayoutSettingsActionControlsRoute: typeof LayoutSettingsActionControlsRoute
  LayoutSettingsBranchesRoute: typeof LayoutSettingsBranchesRoute
  LayoutSettingsInstallmentRoute: typeof LayoutSettingsInstallmentRoute
  LayoutSettingsOperationsRoute: typeof LayoutSettingsOperationsRoute
  LayoutSettingsPoliciesRoute: typeof LayoutSettingsPoliciesRoute
  LayoutSettingsTenantRoute: typeof LayoutSettingsTenantRoute
  LayoutSupportTicketIdRoute: typeof LayoutSupportTicketIdRoute
  LayoutUsersUserIdRoute: typeof LayoutUsersUserIdRoute
  LayoutUsersNewRoute: typeof LayoutUsersNewRoute
  LayoutApplicationsIndexRoute: typeof LayoutApplicationsIndexRoute
  LayoutAuditLogsIndexRoute: typeof LayoutAuditLogsIndexRoute
  LayoutCollectionsIndexRoute: typeof LayoutCollectionsIndexRoute
  LayoutContractsIndexRoute: typeof LayoutContractsIndexRoute
  LayoutCustomersIndexRoute: typeof LayoutCustomersIndexRoute
  LayoutDeviceModelsIndexRoute: typeof LayoutDeviceModelsIndexRoute
  LayoutFeedbackIndexRoute: typeof LayoutFeedbackIndexRoute
  LayoutFinancingPlansIndexRoute: typeof LayoutFinancingPlansIndexRoute
  LayoutInventoryIndexRoute: typeof LayoutInventoryIndexRoute
  LayoutLockEngineIndexRoute: typeof LayoutLockEngineIndexRoute
  LayoutMerchantsIndexRoute: typeof LayoutMerchantsIndexRoute
  LayoutNotificationsIndexRoute: typeof LayoutNotificationsIndexRoute
  LayoutPaymentsIndexRoute: typeof LayoutPaymentsIndexRoute
  LayoutPortfolioIndexRoute: typeof LayoutPortfolioIndexRoute
  LayoutRolesIndexRoute: typeof LayoutRolesIndexRoute
  LayoutSettingsIndexRoute: typeof LayoutSettingsIndexRoute
  LayoutSupportIndexRoute: typeof LayoutSupportIndexRoute
  LayoutUsersIndexRoute: typeof LayoutUsersIndexRoute
  LayoutFinancingPlansPlanIdEditRoute: typeof LayoutFinancingPlansPlanIdEditRoute
  LayoutInventoryUnitsUnitIdRoute: typeof LayoutInventoryUnitsUnitIdRoute
  LayoutInventoryUnitsEnrollRoute: typeof LayoutInventoryUnitsEnrollRoute
  LayoutSettingsOdooOpeningBalancesRoute: typeof LayoutSettingsOdooOpeningBalancesRoute
  LayoutSettingsOdooReconciliationRoute: typeof LayoutSettingsOdooReconciliationRoute
  LayoutSettingsOdooSyncRoute: typeof LayoutSettingsOdooSyncRoute
  LayoutSettingsPlatformProductsRoute: typeof LayoutSettingsPlatformProductsRoute
  LayoutInventoryTransfersIndexRoute: typeof LayoutInventoryTransfersIndexRoute
  LayoutInventoryUnitsIndexRoute: typeof LayoutInventoryUnitsIndexRoute
  LayoutSettingsOdooIndexRoute: typeof LayoutSettingsOdooIndexRoute
  LayoutSettingsPlatformTenantsTenantIdRoute: typeof LayoutSettingsPlatformTenantsTenantIdRoute
  LayoutSettingsPlatformTenantsIndexRoute: typeof LayoutSettingsPlatformTenantsIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutForbiddenRoute: LayoutForbiddenRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutApplicationsApplicationIdRoute: LayoutApplicationsApplicationIdRoute,
  LayoutApplicationsNewRoute: LayoutApplicationsNewRoute,
  LayoutContractsContractIdRoute: LayoutContractsContractIdRoute,
  LayoutCustomersCustomerIdRoute: LayoutCustomersCustomerIdRoute,
  LayoutCustomersNewRoute: LayoutCustomersNewRoute,
  LayoutDeviceModelsModelIdRoute: LayoutDeviceModelsModelIdRoute,
  LayoutDeviceModelsNewRoute: LayoutDeviceModelsNewRoute,
  LayoutFinancingPlansNewRoute: LayoutFinancingPlansNewRoute,
  LayoutLockEngineAutomationRoute: LayoutLockEngineAutomationRoute,
  LayoutLockEnginePoliciesRoute: LayoutLockEnginePoliciesRoute,
  LayoutMerchantsMerchantIdRoute: LayoutMerchantsMerchantIdRoute,
  LayoutMerchantsNewRoute: LayoutMerchantsNewRoute,
  LayoutPaymentsRecordRoute: LayoutPaymentsRecordRoute,
  LayoutRolesRoleIdRoute: LayoutRolesRoleIdRoute,
  LayoutRolesNewRoute: LayoutRolesNewRoute,
  LayoutSettingsActionControlsRoute: LayoutSettingsActionControlsRoute,
  LayoutSettingsBranchesRoute: LayoutSettingsBranchesRoute,
  LayoutSettingsInstallmentRoute: LayoutSettingsInstallmentRoute,
  LayoutSettingsOperationsRoute: LayoutSettingsOperationsRoute,
  LayoutSettingsPoliciesRoute: LayoutSettingsPoliciesRoute,
  LayoutSettingsTenantRoute: LayoutSettingsTenantRoute,
  LayoutSupportTicketIdRoute: LayoutSupportTicketIdRoute,
  LayoutUsersUserIdRoute: LayoutUsersUserIdRoute,
  LayoutUsersNewRoute: LayoutUsersNewRoute,
  LayoutApplicationsIndexRoute: LayoutApplicationsIndexRoute,
  LayoutAuditLogsIndexRoute: LayoutAuditLogsIndexRoute,
  LayoutCollectionsIndexRoute: LayoutCollectionsIndexRoute,
  LayoutContractsIndexRoute: LayoutContractsIndexRoute,
  LayoutCustomersIndexRoute: LayoutCustomersIndexRoute,
  LayoutDeviceModelsIndexRoute: LayoutDeviceModelsIndexRoute,
  LayoutFeedbackIndexRoute: LayoutFeedbackIndexRoute,
  LayoutFinancingPlansIndexRoute: LayoutFinancingPlansIndexRoute,
  LayoutInventoryIndexRoute: LayoutInventoryIndexRoute,
  LayoutLockEngineIndexRoute: LayoutLockEngineIndexRoute,
  LayoutMerchantsIndexRoute: LayoutMerchantsIndexRoute,
  LayoutNotificationsIndexRoute: LayoutNotificationsIndexRoute,
  LayoutPaymentsIndexRoute: LayoutPaymentsIndexRoute,
  LayoutPortfolioIndexRoute: LayoutPortfolioIndexRoute,
  LayoutRolesIndexRoute: LayoutRolesIndexRoute,
  LayoutSettingsIndexRoute: LayoutSettingsIndexRoute,
  LayoutSupportIndexRoute: LayoutSupportIndexRoute,
  LayoutUsersIndexRoute: LayoutUsersIndexRoute,
  LayoutFinancingPlansPlanIdEditRoute: LayoutFinancingPlansPlanIdEditRoute,
  LayoutInventoryUnitsUnitIdRoute: LayoutInventoryUnitsUnitIdRoute,
  LayoutInventoryUnitsEnrollRoute: LayoutInventoryUnitsEnrollRoute,
  LayoutSettingsOdooOpeningBalancesRoute:
    LayoutSettingsOdooOpeningBalancesRoute,
  LayoutSettingsOdooReconciliationRoute: LayoutSettingsOdooReconciliationRoute,
  LayoutSettingsOdooSyncRoute: LayoutSettingsOdooSyncRoute,
  LayoutSettingsPlatformProductsRoute: LayoutSettingsPlatformProductsRoute,
  LayoutInventoryTransfersIndexRoute: LayoutInventoryTransfersIndexRoute,
  LayoutInventoryUnitsIndexRoute: LayoutInventoryUnitsIndexRoute,
  LayoutSettingsOdooIndexRoute: LayoutSettingsOdooIndexRoute,
  LayoutSettingsPlatformTenantsTenantIdRoute:
    LayoutSettingsPlatformTenantsTenantIdRoute,
  LayoutSettingsPlatformTenantsIndexRoute:
    LayoutSettingsPlatformTenantsIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof LayoutRouteWithChildren
  '/terms': typeof TermsRoute
  '/ussd-simulator': typeof UssdSimulatorRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/forbidden': typeof LayoutForbiddenRoute
  '/': typeof LayoutIndexRoute
  '/applications/$applicationId': typeof LayoutApplicationsApplicationIdRoute
  '/applications/new': typeof LayoutApplicationsNewRoute
  '/contracts/$contractId': typeof LayoutContractsContractIdRoute
  '/customers/$customerId': typeof LayoutCustomersCustomerIdRoute
  '/customers/new': typeof LayoutCustomersNewRoute
  '/device-models/$modelId': typeof LayoutDeviceModelsModelIdRoute
  '/device-models/new': typeof LayoutDeviceModelsNewRoute
  '/financing-plans/new': typeof LayoutFinancingPlansNewRoute
  '/lock-engine/automation': typeof LayoutLockEngineAutomationRoute
  '/lock-engine/policies': typeof LayoutLockEnginePoliciesRoute
  '/merchants/$merchantId': typeof LayoutMerchantsMerchantIdRoute
  '/merchants/new': typeof LayoutMerchantsNewRoute
  '/payments/record': typeof LayoutPaymentsRecordRoute
  '/roles/$roleId': typeof LayoutRolesRoleIdRoute
  '/roles/new': typeof LayoutRolesNewRoute
  '/settings/action-controls': typeof LayoutSettingsActionControlsRoute
  '/settings/branches': typeof LayoutSettingsBranchesRoute
  '/settings/installment': typeof LayoutSettingsInstallmentRoute
  '/settings/operations': typeof LayoutSettingsOperationsRoute
  '/settings/policies': typeof LayoutSettingsPoliciesRoute
  '/settings/tenant': typeof LayoutSettingsTenantRoute
  '/support/$ticketId': typeof LayoutSupportTicketIdRoute
  '/users/$userId': typeof LayoutUsersUserIdRoute
  '/users/new': typeof LayoutUsersNewRoute
  '/applications': typeof LayoutApplicationsIndexRoute
  '/audit-logs': typeof LayoutAuditLogsIndexRoute
  '/collections': typeof LayoutCollectionsIndexRoute
  '/contracts': typeof LayoutContractsIndexRoute
  '/customers': typeof LayoutCustomersIndexRoute
  '/device-models': typeof LayoutDeviceModelsIndexRoute
  '/feedback': typeof LayoutFeedbackIndexRoute
  '/financing-plans': typeof LayoutFinancingPlansIndexRoute
  '/inventory': typeof LayoutInventoryIndexRoute
  '/lock-engine': typeof LayoutLockEngineIndexRoute
  '/merchants': typeof LayoutMerchantsIndexRoute
  '/notifications': typeof LayoutNotificationsIndexRoute
  '/payments': typeof LayoutPaymentsIndexRoute
  '/portfolio': typeof LayoutPortfolioIndexRoute
  '/roles': typeof LayoutRolesIndexRoute
  '/settings': typeof LayoutSettingsIndexRoute
  '/support': typeof LayoutSupportIndexRoute
  '/users': typeof LayoutUsersIndexRoute
  '/financing-plans/$planId/edit': typeof LayoutFinancingPlansPlanIdEditRoute
  '/inventory/units/$unitId': typeof LayoutInventoryUnitsUnitIdRoute
  '/inventory/units/enroll': typeof LayoutInventoryUnitsEnrollRoute
  '/settings/odoo/opening-balances': typeof LayoutSettingsOdooOpeningBalancesRoute
  '/settings/odoo/reconciliation': typeof LayoutSettingsOdooReconciliationRoute
  '/settings/odoo/sync': typeof LayoutSettingsOdooSyncRoute
  '/settings/platform/products': typeof LayoutSettingsPlatformProductsRoute
  '/inventory/transfers': typeof LayoutInventoryTransfersIndexRoute
  '/inventory/units': typeof LayoutInventoryUnitsIndexRoute
  '/settings/odoo': typeof LayoutSettingsOdooIndexRoute
  '/settings/platform/tenants/$tenantId': typeof LayoutSettingsPlatformTenantsTenantIdRoute
  '/settings/platform/tenants': typeof LayoutSettingsPlatformTenantsIndexRoute
}

export interface FileRoutesByTo {
  '/terms': typeof TermsRoute
  '/ussd-simulator': typeof UssdSimulatorRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/forbidden': typeof LayoutForbiddenRoute
  '/': typeof LayoutIndexRoute
  '/applications/$applicationId': typeof LayoutApplicationsApplicationIdRoute
  '/applications/new': typeof LayoutApplicationsNewRoute
  '/contracts/$contractId': typeof LayoutContractsContractIdRoute
  '/customers/$customerId': typeof LayoutCustomersCustomerIdRoute
  '/customers/new': typeof LayoutCustomersNewRoute
  '/device-models/$modelId': typeof LayoutDeviceModelsModelIdRoute
  '/device-models/new': typeof LayoutDeviceModelsNewRoute
  '/financing-plans/new': typeof LayoutFinancingPlansNewRoute
  '/lock-engine/automation': typeof LayoutLockEngineAutomationRoute
  '/lock-engine/policies': typeof LayoutLockEnginePoliciesRoute
  '/merchants/$merchantId': typeof LayoutMerchantsMerchantIdRoute
  '/merchants/new': typeof LayoutMerchantsNewRoute
  '/payments/record': typeof LayoutPaymentsRecordRoute
  '/roles/$roleId': typeof LayoutRolesRoleIdRoute
  '/roles/new': typeof LayoutRolesNewRoute
  '/settings/action-controls': typeof LayoutSettingsActionControlsRoute
  '/settings/branches': typeof LayoutSettingsBranchesRoute
  '/settings/installment': typeof LayoutSettingsInstallmentRoute
  '/settings/operations': typeof LayoutSettingsOperationsRoute
  '/settings/policies': typeof LayoutSettingsPoliciesRoute
  '/settings/tenant': typeof LayoutSettingsTenantRoute
  '/support/$ticketId': typeof LayoutSupportTicketIdRoute
  '/users/$userId': typeof LayoutUsersUserIdRoute
  '/users/new': typeof LayoutUsersNewRoute
  '/applications': typeof LayoutApplicationsIndexRoute
  '/audit-logs': typeof LayoutAuditLogsIndexRoute
  '/collections': typeof LayoutCollectionsIndexRoute
  '/contracts': typeof LayoutContractsIndexRoute
  '/customers': typeof LayoutCustomersIndexRoute
  '/device-models': typeof LayoutDeviceModelsIndexRoute
  '/feedback': typeof LayoutFeedbackIndexRoute
  '/financing-plans': typeof LayoutFinancingPlansIndexRoute
  '/inventory': typeof LayoutInventoryIndexRoute
  '/lock-engine': typeof LayoutLockEngineIndexRoute
  '/merchants': typeof LayoutMerchantsIndexRoute
  '/notifications': typeof LayoutNotificationsIndexRoute
  '/payments': typeof LayoutPaymentsIndexRoute
  '/portfolio': typeof LayoutPortfolioIndexRoute
  '/roles': typeof LayoutRolesIndexRoute
  '/settings': typeof LayoutSettingsIndexRoute
  '/support': typeof LayoutSupportIndexRoute
  '/users': typeof LayoutUsersIndexRoute
  '/financing-plans/$planId/edit': typeof LayoutFinancingPlansPlanIdEditRoute
  '/inventory/units/$unitId': typeof LayoutInventoryUnitsUnitIdRoute
  '/inventory/units/enroll': typeof LayoutInventoryUnitsEnrollRoute
  '/settings/odoo/opening-balances': typeof LayoutSettingsOdooOpeningBalancesRoute
  '/settings/odoo/reconciliation': typeof LayoutSettingsOdooReconciliationRoute
  '/settings/odoo/sync': typeof LayoutSettingsOdooSyncRoute
  '/settings/platform/products': typeof LayoutSettingsPlatformProductsRoute
  '/inventory/transfers': typeof LayoutInventoryTransfersIndexRoute
  '/inventory/units': typeof LayoutInventoryUnitsIndexRoute
  '/settings/odoo': typeof LayoutSettingsOdooIndexRoute
  '/settings/platform/tenants/$tenantId': typeof LayoutSettingsPlatformTenantsTenantIdRoute
  '/settings/platform/tenants': typeof LayoutSettingsPlatformTenantsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/terms': typeof TermsRoute
  '/ussd-simulator': typeof UssdSimulatorRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/_layout/forbidden': typeof LayoutForbiddenRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/applications/$applicationId': typeof LayoutApplicationsApplicationIdRoute
  '/_layout/applications/new': typeof LayoutApplicationsNewRoute
  '/_layout/contracts/$contractId': typeof LayoutContractsContractIdRoute
  '/_layout/customers/$customerId': typeof LayoutCustomersCustomerIdRoute
  '/_layout/customers/new': typeof LayoutCustomersNewRoute
  '/_layout/device-models/$modelId': typeof LayoutDeviceModelsModelIdRoute
  '/_layout/device-models/new': typeof LayoutDeviceModelsNewRoute
  '/_layout/financing-plans/new': typeof LayoutFinancingPlansNewRoute
  '/_layout/lock-engine/automation': typeof LayoutLockEngineAutomationRoute
  '/_layout/lock-engine/policies': typeof LayoutLockEnginePoliciesRoute
  '/_layout/merchants/$merchantId': typeof LayoutMerchantsMerchantIdRoute
  '/_layout/merchants/new': typeof LayoutMerchantsNewRoute
  '/_layout/payments/record': typeof LayoutPaymentsRecordRoute
  '/_layout/roles/$roleId': typeof LayoutRolesRoleIdRoute
  '/_layout/roles/new': typeof LayoutRolesNewRoute
  '/_layout/settings/action-controls': typeof LayoutSettingsActionControlsRoute
  '/_layout/settings/branches': typeof LayoutSettingsBranchesRoute
  '/_layout/settings/installment': typeof LayoutSettingsInstallmentRoute
  '/_layout/settings/operations': typeof LayoutSettingsOperationsRoute
  '/_layout/settings/policies': typeof LayoutSettingsPoliciesRoute
  '/_layout/settings/tenant': typeof LayoutSettingsTenantRoute
  '/_layout/support/$ticketId': typeof LayoutSupportTicketIdRoute
  '/_layout/users/$userId': typeof LayoutUsersUserIdRoute
  '/_layout/users/new': typeof LayoutUsersNewRoute
  '/_layout/applications/': typeof LayoutApplicationsIndexRoute
  '/_layout/audit-logs/': typeof LayoutAuditLogsIndexRoute
  '/_layout/collections/': typeof LayoutCollectionsIndexRoute
  '/_layout/contracts/': typeof LayoutContractsIndexRoute
  '/_layout/customers/': typeof LayoutCustomersIndexRoute
  '/_layout/device-models/': typeof LayoutDeviceModelsIndexRoute
  '/_layout/feedback/': typeof LayoutFeedbackIndexRoute
  '/_layout/financing-plans/': typeof LayoutFinancingPlansIndexRoute
  '/_layout/inventory/': typeof LayoutInventoryIndexRoute
  '/_layout/lock-engine/': typeof LayoutLockEngineIndexRoute
  '/_layout/merchants/': typeof LayoutMerchantsIndexRoute
  '/_layout/notifications/': typeof LayoutNotificationsIndexRoute
  '/_layout/payments/': typeof LayoutPaymentsIndexRoute
  '/_layout/portfolio/': typeof LayoutPortfolioIndexRoute
  '/_layout/roles/': typeof LayoutRolesIndexRoute
  '/_layout/settings/': typeof LayoutSettingsIndexRoute
  '/_layout/support/': typeof LayoutSupportIndexRoute
  '/_layout/users/': typeof LayoutUsersIndexRoute
  '/_layout/financing-plans/$planId/edit': typeof LayoutFinancingPlansPlanIdEditRoute
  '/_layout/inventory/units/$unitId': typeof LayoutInventoryUnitsUnitIdRoute
  '/_layout/inventory/units/enroll': typeof LayoutInventoryUnitsEnrollRoute
  '/_layout/settings/odoo/opening-balances': typeof LayoutSettingsOdooOpeningBalancesRoute
  '/_layout/settings/odoo/reconciliation': typeof LayoutSettingsOdooReconciliationRoute
  '/_layout/settings/odoo/sync': typeof LayoutSettingsOdooSyncRoute
  '/_layout/settings/platform/products': typeof LayoutSettingsPlatformProductsRoute
  '/_layout/inventory/transfers/': typeof LayoutInventoryTransfersIndexRoute
  '/_layout/inventory/units/': typeof LayoutInventoryUnitsIndexRoute
  '/_layout/settings/odoo/': typeof LayoutSettingsOdooIndexRoute
  '/_layout/settings/platform/tenants/$tenantId': typeof LayoutSettingsPlatformTenantsTenantIdRoute
  '/_layout/settings/platform/tenants/': typeof LayoutSettingsPlatformTenantsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/terms'
    | '/ussd-simulator'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/forbidden'
    | '/'
    | '/applications/$applicationId'
    | '/applications/new'
    | '/contracts/$contractId'
    | '/customers/$customerId'
    | '/customers/new'
    | '/device-models/$modelId'
    | '/device-models/new'
    | '/financing-plans/new'
    | '/lock-engine/automation'
    | '/lock-engine/policies'
    | '/merchants/$merchantId'
    | '/merchants/new'
    | '/payments/record'
    | '/roles/$roleId'
    | '/roles/new'
    | '/settings/action-controls'
    | '/settings/branches'
    | '/settings/installment'
    | '/settings/operations'
    | '/settings/policies'
    | '/settings/tenant'
    | '/support/$ticketId'
    | '/users/$userId'
    | '/users/new'
    | '/applications'
    | '/audit-logs'
    | '/collections'
    | '/contracts'
    | '/customers'
    | '/device-models'
    | '/feedback'
    | '/financing-plans'
    | '/inventory'
    | '/lock-engine'
    | '/merchants'
    | '/notifications'
    | '/payments'
    | '/portfolio'
    | '/roles'
    | '/settings'
    | '/support'
    | '/users'
    | '/financing-plans/$planId/edit'
    | '/inventory/units/$unitId'
    | '/inventory/units/enroll'
    | '/settings/odoo/opening-balances'
    | '/settings/odoo/reconciliation'
    | '/settings/odoo/sync'
    | '/settings/platform/products'
    | '/inventory/transfers'
    | '/inventory/units'
    | '/settings/odoo'
    | '/settings/platform/tenants/$tenantId'
    | '/settings/platform/tenants'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/terms'
    | '/ussd-simulator'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/forbidden'
    | '/'
    | '/applications/$applicationId'
    | '/applications/new'
    | '/contracts/$contractId'
    | '/customers/$customerId'
    | '/customers/new'
    | '/device-models/$modelId'
    | '/device-models/new'
    | '/financing-plans/new'
    | '/lock-engine/automation'
    | '/lock-engine/policies'
    | '/merchants/$merchantId'
    | '/merchants/new'
    | '/payments/record'
    | '/roles/$roleId'
    | '/roles/new'
    | '/settings/action-controls'
    | '/settings/branches'
    | '/settings/installment'
    | '/settings/operations'
    | '/settings/policies'
    | '/settings/tenant'
    | '/support/$ticketId'
    | '/users/$userId'
    | '/users/new'
    | '/applications'
    | '/audit-logs'
    | '/collections'
    | '/contracts'
    | '/customers'
    | '/device-models'
    | '/feedback'
    | '/financing-plans'
    | '/inventory'
    | '/lock-engine'
    | '/merchants'
    | '/notifications'
    | '/payments'
    | '/portfolio'
    | '/roles'
    | '/settings'
    | '/support'
    | '/users'
    | '/financing-plans/$planId/edit'
    | '/inventory/units/$unitId'
    | '/inventory/units/enroll'
    | '/settings/odoo/opening-balances'
    | '/settings/odoo/reconciliation'
    | '/settings/odoo/sync'
    | '/settings/platform/products'
    | '/inventory/transfers'
    | '/inventory/units'
    | '/settings/odoo'
    | '/settings/platform/tenants/$tenantId'
    | '/settings/platform/tenants'
  id:
    | '__root__'
    | '/_layout'
    | '/terms'
    | '/ussd-simulator'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/reset-password'
    | '/_layout/forbidden'
    | '/_layout/'
    | '/_layout/applications/$applicationId'
    | '/_layout/applications/new'
    | '/_layout/contracts/$contractId'
    | '/_layout/customers/$customerId'
    | '/_layout/customers/new'
    | '/_layout/device-models/$modelId'
    | '/_layout/device-models/new'
    | '/_layout/financing-plans/new'
    | '/_layout/lock-engine/automation'
    | '/_layout/lock-engine/policies'
    | '/_layout/merchants/$merchantId'
    | '/_layout/merchants/new'
    | '/_layout/payments/record'
    | '/_layout/roles/$roleId'
    | '/_layout/roles/new'
    | '/_layout/settings/action-controls'
    | '/_layout/settings/branches'
    | '/_layout/settings/installment'
    | '/_layout/settings/operations'
    | '/_layout/settings/policies'
    | '/_layout/settings/tenant'
    | '/_layout/support/$ticketId'
    | '/_layout/users/$userId'
    | '/_layout/users/new'
    | '/_layout/applications/'
    | '/_layout/audit-logs/'
    | '/_layout/collections/'
    | '/_layout/contracts/'
    | '/_layout/customers/'
    | '/_layout/device-models/'
    | '/_layout/feedback/'
    | '/_layout/financing-plans/'
    | '/_layout/inventory/'
    | '/_layout/lock-engine/'
    | '/_layout/merchants/'
    | '/_layout/notifications/'
    | '/_layout/payments/'
    | '/_layout/portfolio/'
    | '/_layout/roles/'
    | '/_layout/settings/'
    | '/_layout/support/'
    | '/_layout/users/'
    | '/_layout/financing-plans/$planId/edit'
    | '/_layout/inventory/units/$unitId'
    | '/_layout/inventory/units/enroll'
    | '/_layout/settings/odoo/opening-balances'
    | '/_layout/settings/odoo/reconciliation'
    | '/_layout/settings/odoo/sync'
    | '/_layout/settings/platform/products'
    | '/_layout/inventory/transfers/'
    | '/_layout/inventory/units/'
    | '/_layout/settings/odoo/'
    | '/_layout/settings/platform/tenants/$tenantId'
    | '/_layout/settings/platform/tenants/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  TermsRoute: typeof TermsRoute
  UssdSimulatorRoute: typeof UssdSimulatorRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
}

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  TermsRoute: TermsRoute,
  UssdSimulatorRoute: UssdSimulatorRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authResetPasswordRoute: authResetPasswordRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout",
        "/terms",
        "/ussd-simulator",
        "/(auth)/forgot-password",
        "/(auth)/login",
        "/(auth)/reset-password"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/forbidden",
        "/_layout/",
        "/_layout/applications/$applicationId",
        "/_layout/applications/new",
        "/_layout/contracts/$contractId",
        "/_layout/customers/$customerId",
        "/_layout/customers/new",
        "/_layout/device-models/$modelId",
        "/_layout/device-models/new",
        "/_layout/financing-plans/new",
        "/_layout/lock-engine/automation",
        "/_layout/lock-engine/policies",
        "/_layout/merchants/$merchantId",
        "/_layout/merchants/new",
        "/_layout/payments/record",
        "/_layout/roles/$roleId",
        "/_layout/roles/new",
        "/_layout/settings/action-controls",
        "/_layout/settings/branches",
        "/_layout/settings/installment",
        "/_layout/settings/operations",
        "/_layout/settings/policies",
        "/_layout/settings/tenant",
        "/_layout/support/$ticketId",
        "/_layout/users/$userId",
        "/_layout/users/new",
        "/_layout/applications/",
        "/_layout/audit-logs/",
        "/_layout/collections/",
        "/_layout/contracts/",
        "/_layout/customers/",
        "/_layout/device-models/",
        "/_layout/feedback/",
        "/_layout/financing-plans/",
        "/_layout/inventory/",
        "/_layout/lock-engine/",
        "/_layout/merchants/",
        "/_layout/notifications/",
        "/_layout/payments/",
        "/_layout/portfolio/",
        "/_layout/roles/",
        "/_layout/settings/",
        "/_layout/support/",
        "/_layout/users/",
        "/_layout/financing-plans/$planId/edit",
        "/_layout/inventory/units/$unitId",
        "/_layout/inventory/units/enroll",
        "/_layout/settings/odoo/opening-balances",
        "/_layout/settings/odoo/reconciliation",
        "/_layout/settings/odoo/sync",
        "/_layout/settings/platform/products",
        "/_layout/inventory/transfers/",
        "/_layout/inventory/units/",
        "/_layout/settings/odoo/",
        "/_layout/settings/platform/tenants/$tenantId",
        "/_layout/settings/platform/tenants/"
      ]
    },
    "/terms": {
      "filePath": "terms.tsx"
    },
    "/ussd-simulator": {
      "filePath": "ussd-simulator.tsx"
    },
    "/(auth)/forgot-password": {
      "filePath": "(auth)/forgot-password.tsx"
    },
    "/(auth)/login": {
      "filePath": "(auth)/login.tsx"
    },
    "/(auth)/reset-password": {
      "filePath": "(auth)/reset-password.tsx"
    },
    "/_layout/forbidden": {
      "filePath": "_layout/forbidden.tsx",
      "parent": "/_layout"
    },
    "/_layout/": {
      "filePath": "_layout/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/applications/$applicationId": {
      "filePath": "_layout/applications/$applicationId.tsx",
      "parent": "/_layout"
    },
    "/_layout/applications/new": {
      "filePath": "_layout/applications/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/contracts/$contractId": {
      "filePath": "_layout/contracts/$contractId.tsx",
      "parent": "/_layout"
    },
    "/_layout/customers/$customerId": {
      "filePath": "_layout/customers/$customerId.tsx",
      "parent": "/_layout"
    },
    "/_layout/customers/new": {
      "filePath": "_layout/customers/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/device-models/$modelId": {
      "filePath": "_layout/device-models/$modelId.tsx",
      "parent": "/_layout"
    },
    "/_layout/device-models/new": {
      "filePath": "_layout/device-models/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/financing-plans/new": {
      "filePath": "_layout/financing-plans/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/lock-engine/automation": {
      "filePath": "_layout/lock-engine/automation.tsx",
      "parent": "/_layout"
    },
    "/_layout/lock-engine/policies": {
      "filePath": "_layout/lock-engine/policies.tsx",
      "parent": "/_layout"
    },
    "/_layout/merchants/$merchantId": {
      "filePath": "_layout/merchants/$merchantId.tsx",
      "parent": "/_layout"
    },
    "/_layout/merchants/new": {
      "filePath": "_layout/merchants/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/payments/record": {
      "filePath": "_layout/payments/record.tsx",
      "parent": "/_layout"
    },
    "/_layout/roles/$roleId": {
      "filePath": "_layout/roles/$roleId.tsx",
      "parent": "/_layout"
    },
    "/_layout/roles/new": {
      "filePath": "_layout/roles/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/action-controls": {
      "filePath": "_layout/settings/action-controls.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/branches": {
      "filePath": "_layout/settings/branches.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/installment": {
      "filePath": "_layout/settings/installment.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/operations": {
      "filePath": "_layout/settings/operations.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/policies": {
      "filePath": "_layout/settings/policies.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/tenant": {
      "filePath": "_layout/settings/tenant.tsx",
      "parent": "/_layout"
    },
    "/_layout/support/$ticketId": {
      "filePath": "_layout/support/$ticketId.tsx",
      "parent": "/_layout"
    },
    "/_layout/users/$userId": {
      "filePath": "_layout/users/$userId.tsx",
      "parent": "/_layout"
    },
    "/_layout/users/new": {
      "filePath": "_layout/users/new.tsx",
      "parent": "/_layout"
    },
    "/_layout/applications/": {
      "filePath": "_layout/applications/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/audit-logs/": {
      "filePath": "_layout/audit-logs/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/collections/": {
      "filePath": "_layout/collections/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/contracts/": {
      "filePath": "_layout/contracts/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/customers/": {
      "filePath": "_layout/customers/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/device-models/": {
      "filePath": "_layout/device-models/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/feedback/": {
      "filePath": "_layout/feedback/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/financing-plans/": {
      "filePath": "_layout/financing-plans/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/inventory/": {
      "filePath": "_layout/inventory/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/lock-engine/": {
      "filePath": "_layout/lock-engine/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/merchants/": {
      "filePath": "_layout/merchants/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/notifications/": {
      "filePath": "_layout/notifications/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/payments/": {
      "filePath": "_layout/payments/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/portfolio/": {
      "filePath": "_layout/portfolio/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/roles/": {
      "filePath": "_layout/roles/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/": {
      "filePath": "_layout/settings/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/support/": {
      "filePath": "_layout/support/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/users/": {
      "filePath": "_layout/users/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/financing-plans/$planId/edit": {
      "filePath": "_layout/financing-plans/$planId.edit.tsx",
      "parent": "/_layout"
    },
    "/_layout/inventory/units/$unitId": {
      "filePath": "_layout/inventory/units/$unitId.tsx",
      "parent": "/_layout"
    },
    "/_layout/inventory/units/enroll": {
      "filePath": "_layout/inventory/units/enroll.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/odoo/opening-balances": {
      "filePath": "_layout/settings/odoo/opening-balances.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/odoo/reconciliation": {
      "filePath": "_layout/settings/odoo/reconciliation.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/odoo/sync": {
      "filePath": "_layout/settings/odoo/sync.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/platform/products": {
      "filePath": "_layout/settings/platform/products.tsx",
      "parent": "/_layout"
    },
    "/_layout/inventory/transfers/": {
      "filePath": "_layout/inventory/transfers/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/inventory/units/": {
      "filePath": "_layout/inventory/units/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/odoo/": {
      "filePath": "_layout/settings/odoo/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/platform/tenants/$tenantId": {
      "filePath": "_layout/settings/platform/tenants/$tenantId.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings/platform/tenants/": {
      "filePath": "_layout/settings/platform/tenants/index.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
